import { useCurrentVariant } from "../contexts/useCurrentVariant";
import { useCurrentProduct } from "../contexts/useCurrentProduct";
import { useViewerMode } from "../contexts/useViewerMode";
import { useConfig } from "../contexts/useConfig";
import { buildQueryString, getCurrentQueryStringParameters } from "../helpers/helpers";

export function useShareUrl() {
   const [currentModel] = useCurrentVariant();
   const [currentProduct] = useCurrentProduct();
   const [viewerMode,] = useViewerMode();
   const [config] = useConfig();

   if (config && config.customShareUrl) {
      return config.customShareUrl;
   }

   // Guard against undefined state
   if (!config || !config.products || !currentProduct || !currentModel) {
      return window.location.href;
   }

   const productIndex = config.products.findIndex(
      (product) => product.uuid === currentProduct.uuid
   );

   // Default to 0 if product not found
   const validProductIndex = productIndex >= 0 ? productIndex : 0;

   const variantIndex = config.products[validProductIndex].variants.findIndex(
      (variant) => variant.uuid === currentModel.uuid
   );

   // Default to 0 if variant not found
   const validVariantIndex = variantIndex >= 0 ? variantIndex : 0;

   const baseUrl = window.location.origin + window.location.pathname;

   let params = getCurrentQueryStringParameters();
   params = [...params, {
      key: "product",
      value: validProductIndex
   }, {
      key: "variant",
      value: validVariantIndex
   }, {
      key: "show_hotspots",
      value: viewerMode === "explore"
   }]

   const queryString = buildQueryString(params);

   return baseUrl + queryString;

}
